var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.jeet11RetailsBanners || []).length > 0)?_c('div',{staticClass:"scrollContainer"},[_vm._l((_vm.jeet11RetailsBanners),function(banner,index){return [_c('v-flex',{key:index,staticClass:"bannerCard",style:(_vm.jeet11RetailsBanners.length > 1
					? { width: 'calc(95% - 16px)' }
					: { width: '100%' }),attrs:{"pa-2":""},on:{"click":function($event){return _vm.openBannerLink(banner)}}},[_c('img',{staticClass:"bannerImage",attrs:{"src":banner.imageURL}})])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }